import React from 'react'
import { Header, Image, Modal, Icon} from 'semantic-ui-react'
import Button from "../button/Button"

const DeleteConfirmation = ({message, icon, delAPI, toggleFormOn, displayMsg, productLineId}) => {
  const [open, setOpen] = React.useState(false)

  return (
    <Modal
    onClose={() => setOpen(false)}
    onOpen={() => setOpen(true)}
    open={open}
    trigger={<span onClick={(e)=>e.stopPropagation()}>{displayMsg ? displayMsg : ""} <Icon name={icon} color="red" className="delete-modal-icon" size="large" /></span>}
    className="prod-history-modal"
    >
    <Modal.Header>{ icon=="archive alternate" ? <span>Are you sure you want to archive this?</span> : <span>Are you sure you want to delete this?</span>}</Modal.Header>
    <Modal.Content>
        <Modal.Description>
        <Header>Confirm:</Header>
        <p>
            {message}
        </p>
        </Modal.Description>
    </Modal.Content>
    <Modal.Actions>
        <Button className="newButton secondaryBtn btnType1 mediumBtn" onClick={(e) => {setOpen(false); e.stopPropagation()}}>
        Cancel
        </Button>
        <Button
        className="newButton primaryBtn btnType1 mediumBtn"
        onClick={(e) => {
            setOpen(false)
            delAPI(productLineId)
            if(toggleFormOn)
                toggleFormOn()
            e.stopPropagation();
        }}
        >
            {icon == "archive alternate" ? <span>Confirm</span> : <span>Confirm Delete</span>}
        </Button>
    </Modal.Actions>
    </Modal>
  )
}

export default DeleteConfirmation